import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import dayjs from "dayjs";

class ResetAtomForFieldAction extends BaseAction<IDefaultActionResult, string> {

    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: false,
            message: "",
            status: "fail"
        }
        try {
            updateRecoilState("serviceRequestFormDataAtom", {});
            updateRecoilState("searchStateAtom", {
                from: "",
                fromName: "",
                to: "",
                toName: "",
                calc: "",
                passengers: { adults: 1 },
                outboundDate: dayjs(),
                inboundDate: null,
                fromShuttle: false,
                toShuttle: false
            });
            updateRecoilState("bookingResponseAtom", null);
            updateRecoilState("selectedDateAtom", null);
            updateRecoilState("selectedTrainStateAtom", null);
            updateRecoilState("selectedInboundTrainAtom", null);
            updateRecoilState("serviceCategoriesAtom", []);
            updateRecoilState("subServiceCategoriesAtom", []);
            updateRecoilState("selectedTripForServiceRequestAtom", []);
            updateRecoilState("selectedCategoryAndSubCategoryAtom", []);
            actionResult.status = "success"            
        } catch (error) {
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const resetAtomForFieldAction = new ResetAtomForFieldAction()